/**
 * The visitor's Reduce Motion setting (iOS, Android, macOS, Windows all
 * expose it) as the browser reports it. CSS handles its own side through
 * `@media (prefers-reduced-motion: reduce)` in application.css; this is for
 * motion driven from JS — smooth scrolling, scroll reveals, scripted loops.
 *
 * False during SSR and wherever matchMedia is missing: no setting means
 * no reduction, the same default the media query has.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function")
    return false
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}
